import { createContext } from "react"

import type SignUpFormValues from "../types/SignUpFormValues"

export const SignUpFormContext = createContext<{
  values: SignUpFormValues
  setValues: React.Dispatch<React.SetStateAction<SignUpFormValues>>
  wasSignedUp: boolean
  setWasSignedUp: React.Dispatch<React.SetStateAction<boolean>>
}>(null as any)
